






















import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import {CreateChangeUrlResponse, FormField} from "../../../types";
import axiosInstance from "../../axios";
import MessageHelper from "../../helpers/MessageHelper";

@Component({
    components: {},
    props: {
        gameId: {
            required: true,
            type: String,
        },
    }
})

/**
 * Модальное окно заморозки комнаты
 */
export default class ChangeRoomUrlModal extends Vue {
    private gameId!: string;

    private code: FormField = {
        id: 'code',
        name: 'code',
        type: 'text',
        label: '',
        value: '',
        success: true,
        error: null,
        placeholder: 'Введите код',
    };

    private formFields: Array<string> = [
        'code',
    ];

    /**
     * Закрыть модальное окно
     */
    private closeModal(): void {
        this.$emit('close');
    }

    /**
     *
     * @private
     */
    private changeUrl(): void {
        this.createRequest(this.code.value.toString()).then(response => {
            if (response.success) {
                MessageHelper.disableParseMessages();
                MessageHelper.sendMessage('changeGame', {
                    type: 2
                });

                setTimeout(() => {
                    if (response.url) {
                        window.location.href = response.url;
                    }
                }, 200);
            }
        }).catch(error => {
            this.clearValidationErrors();
            this.showValidationErrors(error.errors);
        });
    }

    /**
     * Показать ошибки валидации
     */
    private showValidationErrors(errors: any) {
        this.formFields.forEach((fieldProperty) => {
            const field: FormField = (this as any)[fieldProperty];
            field.success = true;

            for (let attribute in errors) {
                if (errors[attribute].length > 0 && typeof errors[attribute][0] !== 'undefined') {
                    const errorMessage = errors[attribute][0];
                    if (field.name === attribute) {
                        field.error = errorMessage;
                        field.success = false;
                    }
                }
            }
        });
    }

    /**
     * Очищает ошибки валидации
     */
    private clearValidationErrors(): void
    {
        this.formFields.forEach((fieldProperty) => {
            const field: FormField = (this as any)[fieldProperty];
            field.error = null;
        });
    }

    /**
     * Запрос на заморозку комнаты
     * @param code
     * @private
     */
    private createRequest(code: string): Promise<CreateChangeUrlResponse> {
        return new Promise((resolve, reject) => {
            axiosInstance.post(`/game/change-url`, {
                code: code,
                gameId: this.gameId
            })
                .then(response => {
                    if (typeof response.data.errors === 'undefined') {
                        resolve(response.data);
                    } else {
                        reject(response.data);
                    }
                }).catch(error => {
                reject(error);
            });
        });
    }
}
